import { ShippingGroup } from './ShippingGroup';
export { Skeleton } from 'components/aio/ShippingGroup/Skeleton';
export default ShippingGroup;
